import React from 'react';
import RfiDetail from "./RfiDetail";
import RfiEdit from "./RfiEdit";
import {Route} from "react-router";
import {PathBreadcrumbItem, withBreadcrumbCurried} from "../../Boilerplate/BreadcrumbContext";
import {compArr} from "../selectors";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading404} from "../../Boilerplate/deferLoaderHoc";
import {setViewPath} from "../../../actions/view";
import {getRfi} from "../../../actions/rfis";

class Rfi extends React.PureComponent {
  render() {
    return (
      <div>
        <Route exact path="/projects/:id/rfis/:rfiId" component={RfiDetail}/>
        <Route path="/projects/:id/rfis/:rfiId/edit" component={RfiEdit}/>
      </div>
    );
  }
}

const RfiBreadcrumb = props => PathBreadcrumbItem({ path: `/projects/${props.match.params.id}/rfis/`, resource: props.rfi.resource });

export default compose(
  connect(
    (state, props) => {
      const projectId = props.match.params.id;
      const rfi = state.view.subview.data[props.match.params.rfiId];
      const loading = state.view.subview.cache.loading;
      const path = state.view.path;
      const itempath = ['projects', props.match.params.id, 'rfis', props.match.params.rfiId];
      if (!compArr(path, itempath) || loading || !rfi) return { loading: true };
      return { rfi, projectId };
    },
    (dispatch, props) => ({
      preload: () => dispatch(setViewPath(['projects', props.match.params.id, 'rfis', props.match.params.rfiId])),
      loader: () => dispatch(getRfi(props.match.params.id, props.match.params.rfiId)),
    })),
  withLoading404,
  withBreadcrumbCurried(RfiBreadcrumb),
)(Rfi);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/Rfi.js